import React from 'react';
import { NavLink } from 'react-router-dom';
const columns = [
  {
    title: '名字',
    dataIndex: 'studentName',
    key: 'studentName',
    render: (text, record, index) => {
      return <NavLink to={`/student/${record.student}`}>{text}</NavLink>;
    },
  },
  {
    title: '课程类别名称',
    dataIndex: 'courseTypeDisplayName',
    key: 'courseTypeDisplayName',
  },
  {
    title: '试听老师',
    dataIndex: 'trialTeacher',
    key: 'trialTeacher',
  },
  {
    title: '推荐人',
    dataIndex: 'advisor',
    key: 'advisor',
  },
  {
    title: '总计澳币',
    dataIndex: 'total_aud',
    key: 'total_aud',
  },
  {
    title: '付款日期',
    dataIndex: 'transactionDate',
    key: 'transactionDate',
    responsive: ['lg'],
  },
  {
    title: '备注',
    dataIndex: 'comments',
    key: 'comments',
    responsive: ['lg'],
    ellipsis: true,
  },
];

export default { columns };
